import React from 'react';

/**
 *  L'accueil
 * @return {JSX}
 */
function Accueil() {
  return (
    <div>
      <h1>Accueil: Rien à afficher pour le moment</h1>
    </div>
  );
}

export default Accueil;
